import moment from "moment";
import { FiHome, FiSearch, FiUsers, FiSettings, FiMap } from "react-icons/fi";
const navermaps = window.naver.maps;

export const htmlMarkers = {
  htmlMarker1: {
    content:
      '<div style="cursor:pointer;width:40px;height:40px;line-height:42px;font-size:10px;color:white;text-align:center;font-weight:bold;background:url(https://navermaps.github.io/maps.js.ncp/docs/img/cluster-marker-1.png);background-size:contain;"></div>',
    size: navermaps.Size(40, 40),
    anchor: navermaps.Point(20, 20),
  },
  htmlMarker2: {
    content:
      '<div style="cursor:pointer;width:40px;height:40px;line-height:42px;font-size:10px;color:white;text-align:center;font-weight:bold;background:url(https://navermaps.github.io/maps.js.ncp/docs/img/cluster-marker-2.png);background-size:contain;"></div>',
    size: navermaps.Size(40, 40),
    anchor: navermaps.Point(20, 20),
  },
  htmlMarker3: {
    content:
      '<div style="cursor:pointer;width:40px;height:40px;line-height:42px;font-size:10px;color:white;text-align:center;font-weight:bold;background:url(https://navermaps.github.io/maps.js.ncp/docs/img/cluster-marker-3.png);background-size:contain;"></div>',
    size: navermaps.Size(40, 40),
    anchor: navermaps.Point(20, 20),
  },
  htmlMarker4: {
    content:
      '<div style="cursor:pointer;width:40px;height:40px;line-height:42px;font-size:10px;color:white;text-align:center;font-weight:bold;background:url(https://navermaps.github.io/maps.js.ncp/docs/img/cluster-marker-4.png);background-size:contain;"></div>',
    size: navermaps.Size(40, 40),
    anchor: navermaps.Point(20, 20),
  },
  htmlMarker5: {
    content:
      '<div style="cursor:pointer;width:40px;height:40px;line-height:42px;font-size:10px;color:white;text-align:center;font-weight:bold;background:url(https://navermaps.github.io/maps.js.ncp/docs/img/cluster-marker-5.png);background-size:contain;"></div>',
    size: navermaps.Size(40, 40),
    anchor: navermaps.Point(20, 20),
  },
};

export const isGrpMberGbnValue = (item) => {
  if (item.nickNm && item.gbn && item.gbnValue) {
    return <span>{`${item.gbnValue}${item.gbn} ${item.nickNm}`}</span>;
  } else {
    return <span>{item.nickNm ? item.nickNm : "닉네임 미설정"}</span>;
  }
};

export const findMembersByCompanyNo = (cmpnyNo = null, cmpnys = null) => {
  if (!cmpnyNo || !cmpnys) return;

  const cmpnyDetails = cmpnys[cmpnyNo];
  if (cmpnyDetails && Array.isArray(cmpnyDetails) && cmpnyDetails.length > 0) {
    return cmpnyDetails.map((item) => isGrpMberGbnValue(item));
  } else {
    return null;
  }
};

// 권한 병합
export const mergeAuth = (feeds, myGroups) => {
  return feeds.map((feed) => {
    const target = myGroups.find((item) => item.groupNo === parseInt(feed.gbn));
    return target
      ? {
          ...feed,
          auth: target.auth,
        }
      : feed;
  });
};

// 댓글 병합
export const mergeComment = (feeds, comments) => {
  return feeds.map((feed) => ({
    ...feed,
    comments: comments.filter((comment) => feed.feedNo === comment.feedNo),
    showComments: 3,
  }));
};

// 그룹 정보 및 본문 병합
export const mergeGbnValueName = (feeds, myGroups) => {
  return feeds.map((feed) => {
    const target = myGroups.find((item) => item.groupNo === parseInt(feed.gbn));

    if (target) {
      const processContent = (text) => {
        const lineLength = 66;
        const maxLines = 5;
        let isTruncated = false;

        if (text.includes("\n")) {
          const lines = text.split("\n");
          if (lines.length > maxLines) {
            isTruncated = true;
            return { content: lines.slice(0, maxLines).join("\n") + "...", isTruncated };
          }
          return { content: text, isTruncated };
        }

        let formattedText = "";
        for (let i = 0; i < text.length; i += lineLength) {
          formattedText += text.slice(i, i + lineLength) + "\n";
          if (i / lineLength + 1 === maxLines) {
            formattedText += "...";
            isTruncated = true;
            break;
          }
        }

        return { content: formattedText.trim(), isTruncated };
      };

      const { content, isTruncated } = processContent(feed.content);

      return {
        ...feed,
        gbnValueName: target.gbn,
        ...(isTruncated && { realContent: feed.content }),
        content,
        showContent: false,
      };
    }
    return feed;
  });
};

export const isAuth = (feed, user) => {
  return (feed && feed.auth < 2) || user.mberNo === feed.mberNo;
};

export const getTime = (time) => {
  if (!time) return "";

  const now = moment();
  const target = moment(time);

  const years = now.diff(target, "years");
  if (years > 0) {
    return `${years}년 전`;
  }
  const months = now.diff(target, "months");
  if (months > 0) {
    return `${months}달 전`;
  }
  const days = now.diff(target, "days");
  if (days > 0) {
    return `${days}일 전`;
  }
  const hours = now.diff(target, "hours");
  if (hours > 0) {
    return `${hours}시간 전`;
  }
  const minutes = now.diff(target, "minutes");
  if (minutes > 0) {
    return `${minutes}분 전`;
  }
  return "방금 전";
};

export const authOptions = [
  { value: 0, label: "최고관리자" },
  { value: 1, label: "부방장" },
  { value: 2, label: "간부" },
  { value: 3, label: "행동대장" },
  { value: 4, label: "일반" },
];
